<template>
  <div v-if="isLoading" class="spinner-border text-primary m-auto" role="status">
    <span class="visually-hidden">Laden...</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  computed: {
    isLoading () {
      return this.$store.state.loadingStatus
    }
  }
}
</script>

<style>
.spinner-border {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  font-size: 40px !important;
  width: 170px !important;
  height: 170px !important;
  z-index: 9999999 !important;
}
</style>
